import React from 'react';
import { ConfirmDialogV2 } from '../../modal/components/confirm-dialog-v2/ConfirmDialogV2';

export interface ReAuthoriseNodeConfirmationData {
  visible: boolean;
  body?: string;
  BodyComponent?: any;
}

export interface ReAuthoriseNodeConfirmationProps {
  data: ReAuthoriseNodeConfirmationData;
  onClose: Function;
}

export function ReAuthoriseNodeConfirmation({
  data,
  onClose
}: ReAuthoriseNodeConfirmationProps) {
  return (
    <ConfirmDialogV2
      open={data.visible}
      title='Are you sure?'
      positiveButtonText='Yes, I am sure'
      negativeButtonText='Cancel'
      iconName='warning'
      iconContainerClass='warning'
      body={data.body || 'Do you want to reauthorize this account?'}
      BodyComponent={data.BodyComponent}
      onClose={onClose}
    />
  );
}
